<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'INTEGRITY-TOOLS'" [breadcrumb]="''" [count]="count"
    icon=" fa-toolbox">
</app-breadcrumb>
<div class="content-background  p-0">
    <kendo-tabstrip #tabstrip>
        <kendo-tabstrip-tab title="{{ 'INTEGRITY-TOOLS-BATCHES' | translate }}" [selected]="true">
            <ng-template kendoTabContent>
                <div class="row mt-2">
                    <div class="col-sm-12">
                        <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                            <app-advanced-mode id="integrityGridAdvancedSwitch" [storageKey]="'integrity-tools-list'"
                                (collapsibleToggle)="enableAdvanced=$event">
                            </app-advanced-mode>
                            <input #search kendoTextBox class="ml-4 button-search"
                                placeholder="{{ 'SEARCH-COMMENTS' | translate }}"
                                (keyup)="searchFieldChange(search.value)" title="{{ 'SEARCH-COMMENTS' | translate }}" />
                            <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
                        </div>
                    </div>
                </div>
                <div class="mt-3 ml-3 mr-3">
                    <kendo-grid #grid [data]="gridView" [navigable]="true"
                        [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
                        [pageSize]="state.take" [skip]="state.skip" [loading]="loading" [sort]="state.sort"
                        [filter]="state.filter" [sortable]="true" [filterable]="enableAdvanced"
                        [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced"
                        [kendoGridSelectBy]="'id'" [selectedKeys]="selectedRecord"
                        (selectedKeysChange)="onSelectedKeysChange($event)" (dataStateChange)="dataStateChange($event)"
                        (dblclick)="dblClickBatchEvent($event)" [selectable]="{ mode: 'single' }">
                        <kendo-grid-messages noRecords="{{ 'NO-INTEGRITY-BATCHES' | translate }}">
                        </kendo-grid-messages>
                        <ng-template kendoGridToolbarTemplate [position]="'top'" *ngIf="enableAdvanced">
                            <button kendoButton (click)="refresh()" class="float-right">
                                {{'GRID-REFRESH' | translate }}<i class="far fa-sync-alt mt-1"></i>
                            </button>
                        </ng-template>
                        <kendo-grid-column field="integrityTypeName" title="{{ 'INTEGRITY-TYPE' | translate }}"
                            [width]="30" [columnMenu]="false">
                            <ng-template kendoGridFilterCellTemplate let-filter>
                                <app-dropdown-filter [filter]="filter" [data]="integrityTypes"
                                    filterField="integrityType"
                                    selectDefaultText="{{ 'SELECT-INTEGRITY-TYPE' | translate }}" textField="label"
                                    valueField="value">
                                </app-dropdown-filter>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{dataItem.integrityTypeName }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="comments" [width]="60" title="{{'COMMENTS' | translate}}">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <span
                                    title="{{dataItem.comments && dataItem.comments.length > maxTextLength ? dataItem.comments : ''}}">
                                    {{dataItem.comments | truncate: maxTextLength}}
                                </span>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="lastModifiedBy" [width]="40"
                            title="{{ 'LAST-MODIFIED-BY' | translate }}">
                        </kendo-grid-column>
                        <kendo-grid-column field="lastModifiedOn" [width]="40"
                            title="{{ 'LAST-MODIFIED-DATE' | translate }}" filter="date" format="{0:g}">
                        </kendo-grid-column>
                        <kendo-grid-column field="validationErrors" class="text-center"
                            title="{{ 'IMPORT-VALIDATION' | translate }}" filter="boolean" [width]="20">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <i *ngIf="!dataItem.validationErrors" class="fas fa-check-circle valid-status"
                                    title="{{ 'IMPORT-VALIDATION-ERRORS' | translate }}">
                                </i>
                                <i *ngIf="dataItem.validationErrors" class="fas fa-times-circle invalid-status"
                                    title="{{ 'IMPORT-VALIDATION-ERRORS' | translate }}">
                                </i>
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-column field="integrityStageName" title="{{ 'IMPORT-STAGE' | translate }}"
                            [width]="40" [columnMenu]="false">
                            <ng-template kendoGridFilterCellTemplate let-filter>
                                <app-dropdown-filter [filter]="filter" [data]="integrityStages"
                                    filterField="integrityStage"
                                    selectDefaultText="{{ 'SELECT-IMPORT-STAGE' | translate }}" textField="label"
                                    valueField="value">
                                </app-dropdown-filter>
                            </ng-template>
                            <ng-template kendoGridCellTemplate let-dataItem>
                                {{dataItem.integrityStageName }}
                            </ng-template>
                        </kendo-grid-column>
                        <kendo-grid-command-column [width]="30" title="{{ 'ACTIONS' | translate }}" class="text-center">
                            <ng-template kendoGridCellTemplate let-dataItem>
                                <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}"
                                    (click)="editHandler(dataItem['id'])">
                                </i>
                                &nbsp;
                                <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                                    (click)="deleteHandler(dataItem['id'], dataItem['npi'])">
                                </i>
                                &nbsp;
                                <i class="fas fa-file-import fa-lg pointer" style="color: #bc7410;"
                                    title="{{ 'PROCESS-BATCH' | translate }}" (click)="processHandler(dataItem['id'])">
                                </i>
                                &nbsp;
                            </ng-template>
                        </kendo-grid-command-column>
                    </kendo-grid>
                    <div class="float-right mt-3 mb-3">
                        <button kendoButton [primary]="false" type="button" (click)="addHandler()">
                            {{'ADD' | translate}}<i class="far fa-plus"></i>
                        </button>
                    </div>
                </div>
            </ng-template>
        </kendo-tabstrip-tab>
        <kendo-tabstrip-tab title="{{ 'INTEGRITY-TOOLS-ITEMS' | translate }}" [disabled]="!showItemsTab">
            <ng-template kendoTabContent *ngIf="selectedBatch">
                <app-integrity-item-address-list
                    *ngIf="selectedBatch.integrityType === 'ADDRESS_MEMBER' || selectedBatch.integrityType === 'ADDRESS_CARE_TEAM'"
                    [model]="selectedBatch">
                </app-integrity-item-address-list>
            </ng-template>
        </kendo-tabstrip-tab>
    </kendo-tabstrip>
</div>

<!--Add/Edit form-->
<app-integrity-edit [model]="editDataItem" [isNew]="isNew" [integrityTypes]="integrityTypes"
    (save)="saveChangesHandler($event)" (cancelling)="cancelChangesHandler()">
</app-integrity-edit>

<!--Delete confirmation-->
<kendo-dialog *ngIf="deleteDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="deleteDialogOpened = false">
    <p>{{'CONFIRM-INTEGRITY-DELETION' | translate}}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>

<!--Import confirmation dialog-->
<kendo-dialog *ngIf="processDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="processDialogOpened = false">
    <p>{{'CONFIRM-BATCH-PROCESS' | translate}}</p>
    <span class="k-font-weight-bold">{{selectedBatch.integrityTypeName}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="processAction(false)">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="processAction(true)">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>